// Design spread extraction - handles x-position-based page detection
// This module is ONLY used for design view and never affects storyProgress navigation

export function extractDesignContent(book, totalPages) {
  const extractedContent = Array(totalPages).fill(null);
  
  if (!book.spreads || Object.keys(book.spreads).length === 0) {
    console.log('📐 No spreads found in book');
    return null;
  }
  
  for (const spreadId of Object.keys(book.spreads)) {
    if (spreadId === 'spread-0') continue;
    
    const elements = book.spreads[spreadId]?.elements || [];
    
    for (const element of elements) {
      let pageIndex = -1;
      const spreadNumber = parseInt(spreadId.split('-')[1]);
      const isRightPageByPosition = element.position && element.position.x >= 599;
      
      // Determine page based on x position (x >= 599 = right/even page)
      if (isRightPageByPosition) {
        pageIndex = spreadNumber * 2 - 1; // spread-1 -> page 2, spread-2 -> page 4, etc.
      } else if (typeof element.pageNumber === 'number' && element.pageNumber >= 0) {
        pageIndex = element.pageNumber - 1;
      } else {
        pageIndex = spreadNumber * 2 - 2; // spread-1 -> page 1, spread-2 -> page 3, etc.
      }
      
      if (pageIndex >= 0 && pageIndex < totalPages) {
        if (!Array.isArray(extractedContent[pageIndex])) {
          extractedContent[pageIndex] = [];
        }
        
        if (element?.type === 'text' && typeof element.content === 'string' && element.content.trim().length > 0) {
          console.log(`📝 Text element ID ${element.id} placed on page ${pageIndex + 1} (index ${pageIndex})`);
          extractedContent[pageIndex].push({ content: element.content, id: element.id });
          console.log(`📝 Text element in ${spreadId} (x=${element.position?.x}): placed on page ${pageIndex + 1}`);
        } else if (element?.type === 'image') {
          extractedContent[pageIndex].push({ type: 'image', src: element.src, imagePrompt: element.imagePrompt, id: element.id });
          console.log(`🖼️ Image element in ${spreadId} (x=${element.position?.x}): placed on page ${pageIndex + 1}`);
        }
      }
    }
  }
  
  if (extractedContent.some(c => c)) {
    console.log('💭 Found design content to display');
    return extractedContent;
  }
  
  return null;
}
